import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { UsersService } from '../../../pages/users/users.service';
import { GeneralService } from '../../services/general.service';
import { SchoolModule } from './module.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-select-module',
  templateUrl: './select-module.component.html',
  styleUrls: ['./select-module.component.scss'],
  providers: [ UsersService, GeneralService ]
})
export class SelectModuleComponent implements OnInit {
  public modules: SchoolModule[];
  // public businessCtrl = new FormControl([null, Validators.compose([Validators.required])]);
  public moduleCtrl = new FormControl();
  @Output() public onChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() public module: string;

  constructor(private usersService: UsersService, private generalService: GeneralService) {

  }

  ngOnInit() {
    this.generalService.getSchoolModules(AuthService.getUser().business ? AuthService.getUser().business.name : 'notavailable').subscribe(modules => {
      this.modules = modules;
      this.moduleCtrl.setValue(this.module);
    });
  }

  change(e) {
    console.log(e);
    this.onChange.emit(e);
  }

}
